(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';
  var isPanelOpen = false;
  var isLoading = false;
  var PRESERVED_PARAMS = ['sort_by', 'q', 'options[prefix]', 'type'];

  // ── params / AJAX helpers ──────────────────────────────────────────────────

  function buildSearchParams(form) {
    var current = new URLSearchParams(window.location.search);
    var next = new URLSearchParams();
    PRESERVED_PARAMS.forEach(function (key) {
      if (current.has(key)) next.set(key, current.get(key));
    });
    form.querySelectorAll('input.ais-RefinementList-checkbox:checked').forEach(function (input) {
      next.append(input.name, input.value);
    });
    form.querySelectorAll('input[name^="filter.v.price"]').forEach(function (input) {
      if (input.value) next.set(input.name, input.value);
    });
    return next;
  }

  // Exposed so theme.js can call it after its own AJAX replace (e.g. active-filter removal links).
  // Pass preserveOpen=false so the drawer resets to the top-level list instead of re-opening
  // whatever subfacet was last open — the user acted from outside the drawer.
  window._mobileFiltersUpdateDrawer = function(doc) { updateFiltersDrawer(doc, false); };

  function updateFiltersDrawer(doc, preserveOpen) {
    var newDrawer = doc.getElementById('MobileFiltersDrawer');
    var curDrawer = document.getElementById('MobileFiltersDrawer');
    if (!newDrawer || !curDrawer) return;

    // Remember which subfacet was open by its unique ais-facet-* class (before replacing HTML).
    // Index-based tracking breaks when filter groups appear/disappear after unchecking a filter.
    var openFilterClass = null;
    if (preserveOpen !== false) {
      curDrawer.querySelectorAll('.ais-facet-dropdown-wrapper').forEach(function (w) {
        if (!w.classList.contains('subfacet-is-open')) return;
        w.classList.forEach(function (cls) {
          if (cls.startsWith('ais-facet-') && cls !== 'ais-facet-dropdown-wrapper' && cls !== 'ais-facet-conjunctive') {
            openFilterClass = cls;
          }
        });
      });
    }

    var newForm = newDrawer.querySelector('#MobileFiltersForm');
    var curForm = curDrawer.querySelector('#MobileFiltersForm');
    if (newForm && curForm) {
      curForm.innerHTML = newForm.innerHTML;
      updateFooterVar();
    }

    // Restore open subfacet by its stable filter class in the new HTML
    if (openFilterClass) {
      var target = curDrawer.querySelector('.ais-facet-dropdown-wrapper.' + openFilterClass);
      if (target) target.classList.add('subfacet-is-open');
    }
  }

  function applyFilters(form) {
    if (isLoading) return;
    var sectionEl = document.querySelector('[data-collection-template]');
    if (!sectionEl) return;
    var sectionId = sectionEl.getAttribute('data-section-id');
    var params = buildSearchParams(form);
    var paramsStr = params.toString();

    history.pushState({}, '', window.location.pathname + (paramsStr ? '?' + paramsStr : ''));

    isLoading = true;
    var content = document.getElementById('CollectionAjaxContent');
    if (content) content.classList.add('is-loading');
    form.classList.add('is-loading');

    fetch(window.location.pathname + '?section_id=' + sectionId + (paramsStr ? '&' + paramsStr : ''))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.getElementById('CollectionAjaxContent');
        var curContent = document.getElementById('CollectionAjaxContent');
        if (newContent && curContent) {
          curContent.innerHTML = newContent.innerHTML;
          curContent.classList.remove('is-loading');
        }
        updateFiltersDrawer(doc);
        form.classList.remove('is-loading');
        isLoading = false;

        if (window.theme) {
          theme.sections.reinit('collection-template');
          if (window.theme.reinitProductGridItem) theme.reinitProductGridItem();
        }

        // Re-override the open button (theme may have re-wired it)
        bindOpenButton();

        document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { toggleFilters: false, source: 'mobileFilters' } }));
      })
      .catch(function () {
        isLoading = false;
        var content = document.getElementById('CollectionAjaxContent');
        if (content) content.classList.remove('is-loading');
        form.classList.remove('is-loading');
      });
  }

  // ── footer height CSS variable ────────────────────────────────────────────

  function updateFooterVar() {
    var footer = document.querySelector('#MobileFiltersForm .ais-facet-mobile-footer');
    if (!footer) return;
    document.documentElement.style.setProperty('--mf-footer-h', footer.offsetHeight + 'px');
  }

  // ── panel open / close ────────────────────────────────────────────────────

  function openPanel() {
    var panel = document.getElementById('MobileFiltersDrawer');
    if (!panel) return;
    isPanelOpen = true;
    panel.classList.add(OPEN_CLASS);
    document.body.classList.add('mobile-filters-open');
    // Measure footer only when drawer is visible (offsetHeight=0 when display:none)
    updateFooterVar();
  }

  function closePanel() {
    var panel = document.getElementById('MobileFiltersDrawer');
    if (!panel) return;
    isPanelOpen = false;
    panel.classList.remove(OPEN_CLASS);
    document.body.classList.remove('mobile-filters-open');
  }

  // ── ONE-TIME document-level listeners ─────────────────────────────────────
  // These are added once and never need rebinding — they work on the live DOM
  // at the moment of each click/change, regardless of innerHTML replacements.

  document.addEventListener('click', function (evt) {
    var panel = document.getElementById('MobileFiltersDrawer');

    // Open button (outside panel) — capture phase fires before theme's element handler.
    // stopPropagation prevents the event from reaching the button so theme never runs.
    if (evt.target.closest('.collection-filter__btn')) {
      evt.stopPropagation();
      if (panel) panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      return;
    }

    if (!panel || !panel.contains(evt.target)) return;

    // X close button → close entire panel
    if (evt.target.closest('.ais-facets-header__close')) {
      closePanel();
      return;
    }

    // ← back button → close subfacet only, stay in panel
    var backBtn = evt.target.closest('.ais-facet-subfacets__back');
    if (backBtn) {
      var wrapper = backBtn.closest('.ais-facet-dropdown-wrapper');
      if (wrapper) wrapper.classList.remove('subfacet-is-open');
      return;
    }

    // category label → open its subfacet
    var label = evt.target.closest('.ais-facet--header');
    if (label) {
      evt.preventDefault();
      var wrapper = label.closest('.ais-facet-dropdown-wrapper');
      if (wrapper) wrapper.classList.add('subfacet-is-open');
      return;
    }

    // apply / show-results button → just close the panel (products already reloaded via AJAX)
    if (evt.target.closest('.ais-facet-mobile__apply-btn')) {
      evt.preventDefault();
      closePanel();
      return;
    }

    // backdrop (clicking the panel overlay itself) → close
    if (evt.target === panel) closePanel();
  }, true); // capture phase — fires before any direct element handlers

  document.addEventListener('change', function (evt) {
    var form = document.getElementById('MobileFiltersForm');
    if (!form || !form.contains(evt.target)) return;
    if (evt.target.classList.contains('ais-dropdown-checkbox')) return;
    applyFilters(form);
  });

  // ── open button (theme jQuery/Zepto API) ──────────────────────────────────

  function bindOpenButton() {
    var panel = document.getElementById('MobileFiltersDrawer');
    var btn   = document.querySelector('.collection-filter__btn');
    if (!panel || !btn) return;
    try {
      btn.off('click');
      btn.on('click', function () {
        panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      });
    } catch (e) {
      btn.onclick = function () {
        panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      };
    }
  }

  // ── init ──────────────────────────────────────────────────────────────────

  function initMobileFilters() {
    bindOpenButton();
    var panel = document.getElementById('MobileFiltersDrawer');
    if (panel && isPanelOpen) panel.classList.add(OPEN_CLASS);
  }

  window.addEventListener('resize', updateFooterVar);

  document.addEventListener('collection:reloaded', function (evt) {
    var detail = evt.detail || {};
    if (detail.source === 'mobileFilters') return;
    initMobileFilters();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFilters);
  } else {
    initMobileFilters();
  }
})();
